import { useUpdateFeeServiceMutation } from '@/pages/Fleet/Businesses/services/fee-services.service';
import { FeeServiceFormInput, NewFeeService } from '@/pages/Fleet/Businesses/models';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useNotification } from '@/hooks';
import { useCallback } from 'react';

const SUCCESS_MESSAGE = 'Servicio actualizado correctamente';
const ERROR_MESSAGE = 'Ocurrió un error al actualizar el servicio. Inténtalo nuevamente.';
const MISSING_BUSINESS_MESSAGE = 'No se puede actualizar el servicio. Falta información del negocio.';

interface UseUpdateFeeServiceParams {
  feeServiceId: string;
  businessId: string | undefined;
  onSuccess?: () => void;
}

function buildPayload(businessId: string, data: FeeServiceFormInput): NewFeeService {
  return {
    businessId,
    vehicleTypeId: data.vehicleTypeId,
    serviceTypeId: data.serviceTypeId,
    fee: Number(data.fee),
    min: Number(data.min),
    validFrom: data.validFrom,
    validTo: data.validTo,
  };
}

const useUpdateFeeService = ({ feeServiceId, businessId, onSuccess }: UseUpdateFeeServiceParams) => {

  const { showNotification } = useNotification();
  const [updateFeeService] = useUpdateFeeServiceMutation();

  const execute = useCallback(
    
    async (data: FeeServiceFormInput) => {
      if (!businessId) {
        showNotification(MISSING_BUSINESS_MESSAGE, NotificationSeverity.error);
        return;
      }

      const payload = buildPayload(businessId, data);

      try {
        await updateFeeService({ feeServiceId, data: payload }).unwrap();
        showNotification(SUCCESS_MESSAGE, NotificationSeverity.success);
        onSuccess?.();
      } catch {
        showNotification(ERROR_MESSAGE, NotificationSeverity.error);
      }
    },
    [businessId, feeServiceId, updateFeeService, showNotification, onSuccess]
  );

  return execute;
};

export default useUpdateFeeService;
